import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

export function useSearchParam(key: string): string | null {
  const [searchParams] = useSearchParams();

  return useMemo(() => searchParams.get(key), [searchParams, key]);
}
